// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2x3cw","inputWrap":"styles_inputWrap__YYuHk","input":"styles_input__28Rsz"};